import styled from 'styled-components';
import { LABEL, CAPTION } from '@nokia-csf-uxr/freeform-design-tokens/tokens/typography';
import { SPACING_2, SPACING_4, SPACING_8, SPACING_24, SPACING_16 } from '@nokia-csf-uxr/freeform-design-tokens/tokens/spacing';
import { TRANSPARENT } from '@nokia-csf-uxr/freeform-design-tokens/tokens/colors';
import { DEEP_BORDER_BOX } from 'common';

export default {
  StatusBarWrapper: styled.div`
    ${DEEP_BORDER_BOX}
    height: 2.3125rem;
    ${({ $theme, $rtl }) =>
    `
        background-color: ${$theme.background};
        direction: ${$rtl ? 'rtl' : 'ltr'};
        border-top: 0.0625rem solid ${$theme.border};
      `}
    outline: none;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
  `,
  StatusBarSection: styled.div`
    display: flex;
    ${({ $rtl }) => `
    direction: ${$rtl ? 'rtl' : 'ltr'};
    ${$rtl ? 'padding-left' : 'padding-right'} :${SPACING_16};
    `};
    align-items: center;
    justify-content: space-between;
  `,
  StatusBarTextTitle: styled.b`
    ${LABEL}
    font-weight: unset;

    ${({ $rtl, $theme }) =>
    `
        color: ${$theme.content};
        color: ${$theme.content};
        ${$rtl ? `margin-right: ${SPACING_16}` : `margin-left: ${SPACING_16}`};
        direction: ${$rtl ? 'rtl' : 'ltr'};
      `}
  `,
  StatusBarText: styled.span`
    ${CAPTION}
    ${({ $rtl, $theme }) =>
    `
        color: ${$theme.content};
        ${$rtl ? `margin-right: ${SPACING_4}` : `margin-left: ${SPACING_4}`};
        direction: ${$rtl ? 'rtl' : 'ltr'};
      `}
  `,
  StatusBarPagination: styled.div`
    ${({ $rtl }) =>
    `
        direction: ${$rtl ? 'rtl' : 'ltr'};
      `}
    display: flex;
    align-items: center;
    padding: 0 ${SPACING_16};
  `,
  StatusBarPaginationIcon: styled.div`
    margin: 0 ${SPACING_4};
  `,
  StatusBarPaginationGap: styled.div`
    width: ${SPACING_16};
  `,
  StatusBarPaginationInput: styled.input`
    ${LABEL}
    border: none;
    outline: none;
    background-color: ${TRANSPARENT};
    width: ${SPACING_24};
    min-width: ${SPACING_24};
    height: 1rem;
    border-radius: unset;
    text-align: end;
    ${({ $rtl, $theme }) =>
    `
        color: ${$theme.content};
        direction: ${$rtl ? 'rtl' : 'ltr'};
        ${$rtl ? `margin-right: ${SPACING_4}` : `margin-left: ${SPACING_4}`};
        box-shadow: inset 0 -0.0625rem 0 0 ${$theme.input.inactive.border};
        &:focus {
          box-shadow: inset 0 -0.0625rem 0 0 ${$theme.input.active.border};
        }
        &:hover {
          box-shadow: inset 0px -${SPACING_2} 0px 0px  ${$theme.input.hover.border};
        }
      `}
  `,
  StatusBarToggleSwitch: styled.div`
    ${({ $rtl }) =>
    `
        ${$rtl ? `margin-right: ${SPACING_8}` : `margin-left: ${SPACING_8}`};
        direction: ${$rtl ? 'rtl' : 'ltr'};
      `}
  `
};
